/**
 * Generated from PuppetLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.generator&&(e[t]=e.generator(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function PuppetLayout(this: $PuppetLayout) {
	$(this, "main", main, {x:512, y:384, sx:0.500, sy:0.500});
	return this;
}
export function main(this: $main) {
	const buttons = this.buttons;
	$(buttons, 0, buttonBackground, {x:-604.85, y:604.75, w:320.00, h: 327.00});
	$(buttons, 1, buttonCharacter, {x:-279.3, y:604.75, w:320.00, h: 327.00});
	$(buttons, 2, buttonProp, {x:46.25, y:604.75, w:320.00, h: 327.00});
	$(this, "vignette", vignette, {x:0, y:0, w:3328.00, h: 1536.00});
	$(this, "screen", screen, {x:-73.2, y:-174.65});
	$(this, "buttonSubmitPos", buttonSubmit, {x:855.65, y:12.25, w:271.00, h: 282.00});
	$(this, "buttonLight", buttonLight, {x:371.9, y:604.75, w:320.00, h: 327.00});
	return this;
}
function vignette(this: $vignette) {
	if (this.setLayoutTexture) this.setLayoutTexture("vignette.png", 0.500, 0.500);
	return this;
}
export function screen(this: $screen) {
	const items = this.items;
	$(items, 0, backgroundItems, {x:-513.5, y:320});
	$(items, 1, characterItems, {x:28.95, y:549.3});
	$(items, 2, propItems, {x:368.85, y:422});
	$(items, 3, backgroundItems, {x:444.1, y:320, sx:-1.000});
	$(items, 4, propItems, {x:-437.55, y:422, sx:-1.000});
	$(this, "screen", screenSprite, {x:0, y:0, w:1849.00, h: 1372.00});
	$(this, "ropeLeft", ropeLeft, {x:-1124.9, y:-671.6, w:508.00, h: 540.00});
	$(this, "ropeRight", ropeRight, {x:1057.35, y:-742.2, w:495.00, h: 415.00});
	$(this, "screenLight", screenLight, {x:-44.65, y:37, w:1735.00, h: 1129.00});
	$(this, "screenArea", screenArea, {x:-826.5, y:-410.3, w:1581.50, h:917.90});
	return this;
}
function screenSprite(this: $screenSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("screen.png", 0.500, 0.500);
	return this;
}
function ropeLeft(this: $ropeLeft) {
	if (this.setLayoutTexture) this.setLayoutTexture("rope-left.png", 0.500, 0.500);
	return this;
}
function ropeRight(this: $ropeRight) {
	if (this.setLayoutTexture) this.setLayoutTexture("rope-right.png", 0.500, 0.500);
	return this;
}
function screenLight(this: $screenLight) {
	if (this.setLayoutTexture) this.setLayoutTexture("screen-light.png", 0.500, 0.500);
	return this;
}
function backgroundItems(this: $backgroundItems) {
	const sprites = this.sprites;
	$(sprites, 0, backgroundCloud, {x:0, y:-223.6, w:490.00, h: 428.00});
	$(sprites, 1, backgroundIsland, {x:0, y:0, w:576.00, h: 601.00});
	$(sprites, 2, backgroundWave, {x:0, y:0, w:415.00, h: 661.00});
	return this;
}
function backgroundCloud(this: $backgroundCloud) {
	if (this.setLayoutTexture) this.setLayoutTexture("background-cloud.png", 0.482, 1.000);
	return this;
}
function backgroundIsland(this: $backgroundIsland) {
	if (this.setLayoutTexture) this.setLayoutTexture("background-island.png", 0.533, 1.000);
	return this;
}
function backgroundWave(this: $backgroundWave) {
	if (this.setLayoutTexture) this.setLayoutTexture("background-wave.png", 0.463, 1.000);
	return this;
}
function propItems(this: $propItems) {
	const sprites = this.sprites;
	$(sprites, 0, propHelicopter, {x:0, y:0, w:626.00, h: 734.00});
	$(sprites, 1, propBoat, {x:-1.6, y:0, w:613.00, h: 383.00});
	return this;
}
function propHelicopter(this: $propHelicopter) {
	if (this.setLayoutTexture) this.setLayoutTexture("prop-helicopter.png", 0.396, 1.000);
	return this;
}
function propBoat(this: $propBoat) {
	if (this.setLayoutTexture) this.setLayoutTexture("prop-boat.png", 0.568, 1.000);
	return this;
}
function characterItems(this: $characterItems) {
	const sprites = this.sprites;
	$(sprites, 0, characterLuna, {x:0, y:0, w:603.00, h: 695.00});
	$(sprites, 1, characterCarmen, {x:0, y:0, w:311.00, h: 548.00});
	$(sprites, 2, characterLeo, {x:0, y:0, w:247.00, h: 497.00});
	$(sprites, 3, characterAndy, {x:0, y:0, w:242.00, h: 473.00});
	return this;
}
function characterLuna(this: $characterLuna) {
	if (this.setLayoutTexture) this.setLayoutTexture("character-luna.png", 0.630, 1.000);
	return this;
}
function characterCarmen(this: $characterCarmen) {
	if (this.setLayoutTexture) this.setLayoutTexture("character-carmen.png", 0.296, 1.000);
	return this;
}
function characterLeo(this: $characterLeo) {
	if (this.setLayoutTexture) this.setLayoutTexture("character-leo.png", 0.806, 1.000);
	return this;
}
function characterAndy(this: $characterAndy) {
	if (this.setLayoutTexture) this.setLayoutTexture("character-andy.png", 0.723, 1.000);
	return this;
}
function screenArea(this: $screenArea) {
	return this;
}
function buttonSubmit(this: $buttonSubmit) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-submit.png", 0.500, 0.500);
	return this;
}
function buttonBackground(this: $buttonBackground) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-background.png", 0.500, 0.500);
	return this;
}
function buttonCharacter(this: $buttonCharacter) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-character.png", 0.500, 0.500);
	return this;
}
function buttonProp(this: $buttonProp) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-prop.png", 0.500, 0.500);
	return this;
}
function buttonLight(this: $buttonLight) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-light-on.png", 0.500, 0.502);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	generator?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $PuppetLayout {
	readonly main: $main;
}
interface $main extends $$container {
	readonly buttons: $$array<$buttonBackground|$buttonCharacter|$buttonProp>;
	readonly vignette: $vignette;
	readonly screen: $screen;
	readonly buttonSubmitPos: $buttonSubmit;
	readonly buttonLight: $buttonLight;
}
interface $vignette extends $$sprite {
}
interface $screen extends $$container {
	readonly items: $$array<$backgroundItems|$characterItems|$propItems>;
	readonly screen: $screenSprite;
	readonly ropeLeft: $ropeLeft;
	readonly ropeRight: $ropeRight;
	readonly screenLight: $screenLight;
	readonly screenArea: $screenArea;
}
interface $screenSprite extends $$sprite {
}
interface $ropeLeft extends $$sprite {
}
interface $ropeRight extends $$sprite {
}
interface $screenLight extends $$sprite {
}
interface $backgroundItems extends $$container {
	readonly sprites: $$array<$backgroundCloud|$backgroundIsland|$backgroundWave>;
}
interface $backgroundCloud extends $$sprite {
}
interface $backgroundIsland extends $$sprite {
}
interface $backgroundWave extends $$sprite {
}
interface $propItems extends $$container {
	readonly sprites: $$array<$propHelicopter|$propBoat>;
}
interface $propHelicopter extends $$sprite {
}
interface $propBoat extends $$sprite {
}
interface $characterItems extends $$container {
	readonly sprites: $$array<$characterLuna|$characterCarmen|$characterLeo|$characterAndy>;
}
interface $characterLuna extends $$sprite {
}
interface $characterCarmen extends $$sprite {
}
interface $characterLeo extends $$sprite {
}
interface $characterAndy extends $$sprite {
}
interface $screenArea extends $$container {
}
interface $buttonSubmit extends $$sprite {
}
interface $buttonBackground extends $$sprite {
}
interface $buttonCharacter extends $$sprite {
}
interface $buttonProp extends $$sprite {
}
interface $buttonLight extends $$sprite {
}
